import { TabContent, TabPane } from "reactstrap";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";
import { SimpleTabData } from "../../../../Data/UiKits/Tabs";

const SimpleTabContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {SimpleTabData &&
        SimpleTabData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
};
export default SimpleTabContent;
